module.exports = __webpack_public_path__ + "img/default.2f0e20b0.svg";